export class CityUserController {

    constructor(store) {
        this.store = store;
    }

    async onCityChange(colleague) {
        let selectedColleague = null;
        if (this.store.level.cityCaller === 'OFFICE') {selectedColleague = await this.store.datas.findOne('USERS', 'name', colleague.label);
        } else if (this.store.level.cityCaller === 'USER') {selectedColleague = colleague;}

        // Megnézzük, hogy létezik-e már CITYUSERS rekord
        let cityUserData = await this.store.datas.existingCityUserEntry(this.store.level.selectedCity.id, selectedColleague.id);

        let alreadyThere = this.store.level.cityColleagues.filter(colleague => colleague.id === selectedColleague.id);
        if(alreadyThere.length > 0){
            this.store.toast.warning('Ez a kolléga már hozzá van rendelve a településhez.');
            this.store.level.cityuser = false;
            this.store.levelController.setLevel({name: "MAP", hit: null});
        }else{
            // MEGERŐSÍTÉS
            this.store.database.moveFrom = selectedColleague;
            this.store.database.moveTo = this.store.level.selectedCity;
            const answer = await this.store.toast.choose("KOLLÉGA HOZZÁADÁSA A TELEPÜLÉSHEZ");
            if (!answer) {
                this.store.level.cityuser = false;
                return;
            }
            this.store.level.cityuser = false;
            this.store.levelController.setLevel({name: "MAP", hit: null});
            //ADATBÁZISMŰVELET
            if (cityUserData.process === 'MODIFY') {
                cityUserData.existingCityUsersEntry.isthere = 'IGAZ';
                await this.store.datas.modify('CITYUSERS', cityUserData.existingCityUsersEntry, null);
            } else if (cityUserData.process === 'SAVE') {
                const newCityUserEntry = {
                    userid: selectedColleague.id,
                    wasthere: "HAMIS",
                    cityid: this.store.level.selectedCity.id,
                    isthere: "IGAZ",
                    id: 0,
                    firestoreid: ""
                };
                await this.store.datas.save('CITYUSERS', newCityUserEntry, null);
            }
        }
    }

    async removeColleague(cityid, userid) {
        // Megnézzük, hogy létezik-e már CITYUSERS rekord
        let cityUserData = await this.store.datas.existingCityUserEntry(cityid, userid)
        cityUserData.existingCityUsersEntry.isthere = 'HAMIS';
        // MEGERŐSÍTÉS
        this.store.database.moveFrom = await this.store.datas.findOne('USERS', 'id', userid)
        this.store.database.moveTo = await this.store.datas.findOne('CITIES', 'id', cityid)
        const answer = await this.store.toast.choose("KOLLÉGA ELTÁVOLÍTÁSA A TELEPÜLÉSRŐL");
        if (!answer) {
            this.store.level.cityuser = false;
            return;
        }
        this.store.level.cityuser = false;
        this.store.levelController.setLevel({name: "MAP", hit: null});
        await this.store.datas.modify('CITYUSERS', cityUserData.existingCityUsersEntry, null);
    }
}